import ReactGA from "react-ga4";

const InitializeGoogleAnalytics = () => {
  ReactGA.initialize([
    {
      trackingId: "G-9ZY846XGP5" 
    },
  ]);
}

declare global {
  interface Window {
    gaEvent:(category:string,action:string,label:string) => void;
  }
}

(window as any).gaEvent = (category:string, action:string, label:string) => {
  if(ReactGA){
    ReactGA.event({
      category: category,
      action: action,
      label:label
    });     
  }
}


export default InitializeGoogleAnalytics